// extracted by mini-css-extract-plugin
export default {"rootClassName":"status-icon"};